var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { updateByCollectionResponse } from "framework/state/collection";
import { load, loadLast, update } from "framework/state/loader";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { setEntityField } from "framework/state/setfield";
import { NoEntityError, updateByEntityResponse } from "framework/validation/validatableentity";
import { createHook, createStore } from "react-sweet-state";
import { apiGetRanklist, apiGetRanklists, apiHideRanklist, apiPublishRanklist, apiRecalculateRanklist } from "./endpoint";
import { RanklistStatus } from "./entity";
import { AgeType, CompetitorType, DisciplineType, SeriesType } from "public_app/events/entity";
// Filter
export var ranklistCompetitorTypeValues = [
    'CoupleAmateur',
    'CoupleProfessional',
    'DuoTPV',
    'SoloTPV',
    'GroupTPV',
];
export var competitorTypeToString = function (ranklistCompetitorType) {
    if (ranklistCompetitorType === 'CoupleAmateur') {
        return "Páry (Výkonnostní sport)";
    }
    if (ranklistCompetitorType === 'CoupleProfessional') {
        return "Páry (Profesionálové)";
    }
    if (ranklistCompetitorType === 'DuoTPV') {
        return "Dua (TPV)";
    }
    if (ranklistCompetitorType === 'SoloTPV') {
        return "Jednotlivci (TPV)";
    }
    if (ranklistCompetitorType === 'GroupTPV') {
        return "Skupiny - G-Cup";
    }
    return '';
};
var ranklistAgeValuesAmateur = [
    AgeType.Junior_I,
    AgeType.Junior_II,
    AgeType.Youth,
    AgeType.Under_21,
    AgeType.Adult,
    AgeType.Senior_I,
    AgeType.Senior_II,
    AgeType.Senior_III,
    AgeType.Senior_IV,
];
var ranklistAgeValuesProfessional = [
    AgeType.Adult,
    AgeType.Senior_I,
    AgeType.Senior_II,
    AgeType.Senior_III,
    AgeType.Senior_IV,
];
var ranklistAgeValuesTPV = [
    AgeType.Junior_I,
    AgeType.Junior_II,
    AgeType.Youth,
    AgeType.Under_21,
    AgeType.Adult,
];
export var getRanklistAgeValues = function (ranklistCompetitorType) {
    if (ranklistCompetitorType === 'CoupleAmateur') {
        return ranklistAgeValuesAmateur;
    }
    if (ranklistCompetitorType === 'CoupleProfessional') {
        return ranklistAgeValuesProfessional;
    }
    if (ranklistCompetitorType === 'DuoTPV') {
        return ranklistAgeValuesTPV;
    }
    if (ranklistCompetitorType === 'SoloTPV') {
        return ranklistAgeValuesTPV;
    }
    if (ranklistCompetitorType === 'GroupTPV') {
        return ranklistAgeValuesTPV;
    }
    return ranklistAgeValuesAmateur;
};
var ranklistDisciplineValues = [
    DisciplineType.Standard,
    DisciplineType.Latin,
    DisciplineType.TenDance,
];
var ranklistDisciplineValuesTPV = [
    DisciplineType.Standard,
    DisciplineType.Latin,
];
export var getRanklistDisciplineValues = function (ranklistCompetitorType) {
    if (ranklistCompetitorType === 'CoupleAmateur') {
        return ranklistDisciplineValues;
    }
    if (ranklistCompetitorType === 'CoupleProfessional') {
        return ranklistDisciplineValues;
    }
    if (ranklistCompetitorType === 'DuoTPV') {
        return ranklistDisciplineValuesTPV;
    }
    if (ranklistCompetitorType === 'SoloTPV') {
        return ranklistDisciplineValuesTPV;
    }
    if (ranklistCompetitorType === 'GroupTPV') {
        return ranklistDisciplineValuesTPV;
    }
    return ranklistDisciplineValues;
};
var FilterStateDefaults = {
    entity: {
        competitorType: null,
        age: null,
        discipline: null,
        chosenRanklistId: null,
    },
    errors: __assign({}, NoEntityError),
};
var setFilterEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.filter, field, value, validator, storeInvalidValue);
        if (field === 'competitorType') {
            // if (value === 'CoupleAmateur') {
            //     if (draft.filter.entity.age !== null && !ranklistAgeValuesAmateur.map(v => v.toString()).includes(draft.filter.entity.age)) {
            //         draft.filter.entity.age = null;
            //     }
            // }
            if (value === 'CoupleProfessional') {
                if (draft.filter.entity.age !== null && draft.filter.entity.age !== 'null' && !ranklistAgeValuesProfessional.map(function (v) { return v.toString(); }).includes(draft.filter.entity.age)) {
                    draft.filter.entity.age = 'null';
                }
            }
            // if (value === 'CoupleAmateur' || value === 'CoupleProfessional') {
            //     if (draft.filter.entity.discipline !== null && !ranklistDisciplineValues.map(v => v.toString()).includes(draft.filter.entity.discipline)) {
            //         draft.filter.entity.discipline = null;
            //     }
            // }
            if (value === 'DuoTPV' || value === 'SoloTPV' || value === 'GroupTPV') {
                if (draft.filter.entity.age !== null && draft.filter.entity.age !== 'null' && !ranklistAgeValuesTPV.map(function (v) { return v.toString(); }).includes(draft.filter.entity.age)) {
                    draft.filter.entity.age = 'null';
                }
                if (draft.filter.entity.discipline !== null && draft.filter.entity.discipline !== 'null' && !ranklistDisciplineValuesTPV.map(function (v) { return v.toString(); }).includes(draft.filter.entity.discipline)) {
                    draft.filter.entity.discipline = 'null';
                }
            }
        }
    });
    if (field !== 'chosenRanklistId') {
        filterRanklists(store);
    }
}; };
var RanklistStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError), openedDetailedInfoForCompetitorIds: [] });
var loadRanklist = function (ranklistId) { return function (store) {
    var loader = function () { return apiGetRanklist(ranklistId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.ranklist, response);
            draft.ranklist.openedDetailedInfoForCompetitorIds = [];
        });
    };
    load(store, loader, stateProducer, function (s) { return s.ranklist; });
}; };
var openOrCloseCompetitorDetail = function (competitorId) { return function (store) {
    store.setState(function (draft) {
        var idx = draft.ranklist.openedDetailedInfoForCompetitorIds.indexOf(competitorId);
        if (idx >= 0) {
            draft.ranklist.openedDetailedInfoForCompetitorIds.splice(idx, 1);
        }
        else {
            draft.ranklist.openedDetailedInfoForCompetitorIds.push(competitorId);
        }
    });
}; };
var filterRanklists = function (store) {
    var state = store.getState();
    var seriesFilter = null;
    var competitorTypeFilter = null;
    if (state.filter.entity.competitorType === 'CoupleAmateur') {
        seriesFilter = SeriesType.DanceSport;
        competitorTypeFilter = CompetitorType.Couple;
    }
    else if (state.filter.entity.competitorType === 'CoupleProfessional') {
        seriesFilter = SeriesType.Professional;
        competitorTypeFilter = CompetitorType.Couple;
    }
    else if (state.filter.entity.competitorType === 'DuoTPV') {
        seriesFilter = SeriesType.DanceForAll;
        competitorTypeFilter = CompetitorType.Duo;
    }
    else if (state.filter.entity.competitorType === 'SoloTPV') {
        seriesFilter = SeriesType.DanceForAll;
        competitorTypeFilter = CompetitorType.SoloDancer;
    }
    else if (state.filter.entity.competitorType === 'GroupTPV') {
        seriesFilter = SeriesType.DanceForAll;
        competitorTypeFilter = CompetitorType.Group;
    }
    store.setState(function (draft) {
        if (draft.filter.entity.age !== null && draft.filter.entity.age !== 'null'
            && draft.filter.entity.discipline !== null && draft.filter.entity.discipline !== 'null'
            && seriesFilter !== null
            && competitorTypeFilter !== null) {
            draft.filtered_ranklists = draft.ranklists.collection.filter(function (r) {
                if (r.discipline.toString() === draft.filter.entity.discipline
                    && r.age.toString() === draft.filter.entity.age
                    && r.series === seriesFilter
                    && r.competitorType === competitorTypeFilter) {
                    return true;
                }
                return false;
            });
            if (!draft.filtered_ranklists.map(function (r) { return r.id; }).includes(parseInt(draft.filter.entity.chosenRanklistId))) {
                draft.filter.entity.chosenRanklistId = null;
            }
        }
        else {
            draft.filtered_ranklists = [];
            draft.filter.entity.chosenRanklistId = null;
        }
    });
    fillNewestRanklistIfPossible(store);
};
var fillNewestRanklistIfPossible = function (store) {
    store.setState(function (draft) {
        if (draft.filtered_ranklists.length > 0) {
            draft.filter.entity.chosenRanklistId = draft.filtered_ranklists[0].id.toString();
        }
    });
};
var updateRanklistStatus = function (ranklistId, val) { return function (store) {
    var updater = function () { return val === RanklistStatus.Private
        ? apiHideRanklist(ranklistId)
        : apiPublishRanklist(ranklistId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.ranklist, response);
            draft.ranklist.openedDetailedInfoForCompetitorIds = [];
        });
    };
    update(store, updater, stateProducer, function (s) { return s.ranklist; });
}; };
var recalculateRanklist = function (ranklistId) { return function (store) {
    var updater = function () { return apiRecalculateRanklist(ranklistId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.ranklist, response);
            draft.ranklist.openedDetailedInfoForCompetitorIds = [];
        });
    };
    update(store, updater, stateProducer, function (s) { return s.ranklist; });
}; };
var RanklistsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var loadRanklists = function () { return function (store) {
    var loader = function () { return apiGetRanklists(); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.ranklists, response);
        });
        filterRanklists(store);
    };
    loadLast(store, loader, stateProducer, function (s) { return s.ranklists; });
}; };
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { filter: FilterStateDefaults, ranklists: RanklistsStateDefaults, ranklist: RanklistStateDefaults, filtered_ranklists: [] });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        setFilterEntityField: setFilterEntityField,
        loadRanklists: loadRanklists,
        loadRanklist: loadRanklist,
        openOrCloseCompetitorDetail: openOrCloseCompetitorDetail,
        updateRanklistStatus: updateRanklistStatus,
        recalculateRanklist: recalculateRanklist,
    },
    name: "Ranklists"
});
var useState = createHook(store);
export { useState as useRankLists, };
